import { __module as x } from "./ghl-ui.es1712.js";
import { i as $ } from "./ghl-ui.es1541.js";
import { t as w } from "./ghl-ui.es1631.js";
import { r as b } from "./ghl-ui.es1637.js";
import { s as h } from "./ghl-ui.es1710.js";
import { t as q } from "./ghl-ui.es1636.js";
import "./ghl-ui.es1638.js";
import { __exports as y } from "./ghl-ui.es1641.js";
(function(g, o) {
  var r = $.default;
  Object.defineProperty(o, "__esModule", {
    value: !0
  }), o.default = c;
  var k = r(w), W = r(b), C = r(h), D = r(q), O = y;
  function c(Y, e) {
    var i, l, s, n, f, u, d, v;
    (0, W.default)(1, arguments);
    var p = (0, k.default)(Y), t = p.getUTCFullYear(), T = (0, O.getDefaultOptions)(), a = (0, D.default)((i = (l = (s = (n = e == null ? void 0 : e.firstWeekContainsDate) !== null && n !== void 0 ? n : e == null || (f = e.locale) === null || f === void 0 || (u = f.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && s !== void 0 ? s : T.firstWeekContainsDate) !== null && l !== void 0 ? l : (d = T.locale) === null || d === void 0 || (v = d.options) === null || v === void 0 ? void 0 : v.firstWeekContainsDate) !== null && i !== void 0 ? i : 1);
    if (!(a >= 1 && a <= 7))
      throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var m = /* @__PURE__ */ new Date(0);
    m.setUTCFullYear(t + 1, 0, a), m.setUTCHours(0, 0, 0, 0);
    var U = (0, C.default)(m, e), _ = /* @__PURE__ */ new Date(0);
    _.setUTCFullYear(t, 0, a), _.setUTCHours(0, 0, 0, 0);
    var E = (0, C.default)(_, e);
    return p.getTime() >= U.getTime() ? t + 1 : p.getTime() >= E.getTime() ? t : t - 1;
  }
  g.exports = o.default;
})(x, x.exports);
var P = x.exports;
export {
  P as g
};
